import React, { useState } from 'react';
import InventoryCard from "./sections/InventoryCards";
import InventoryTable from "./sections/InventoryTable";
import EditInventoryModal from "./sections/modals/EditInventoryModal";

/**
 * Catering Inventory Management Page
 * Displays catering Inventory statistics and table with add functionality
 */
const InventoryControlPage = () => {
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [refetchTrigger, setRefetchTrigger] = useState(0); // Add this to force refresh

  // Handle modal actions
  const handleAddEvent = () => {
    setIsAddModalVisible(true);
  };

  const handleCloseAddModal = () => {
    setIsAddModalVisible(false);
  };

  const handleAddSuccess = () => {
    // console.log('Inventory created successfully');
    setRefetchTrigger(prev => prev + 1); // Trigger refetch
  };

  const handleEditEvent = (record) => {
    setSelectedEvent(record);
    setIsEditModalVisible(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedEvent(null);
  };

  const handleEditSuccess = () => {
    // console.log('Inventory updated successfully');
    setRefetchTrigger(prev => prev + 1); // Trigger refetch
  };

  const handleViewEvent = (record) => {
    setSelectedEvent(record);
    setIsViewModalVisible(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalVisible(false);
    setSelectedEvent(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto py-8">
        <div className='flex flex-col gap-6'>
          {/* Catering Inventory Statistics Cards */}
          <InventoryCard />

          {/* Catering Inventory Table */}
          <InventoryTable
            onAddEvent={handleAddEvent}
            onEditEvent={handleEditEvent}
            onViewEvent={handleViewEvent}
            refetchTrigger={refetchTrigger} // Pass the trigger
          />
        </div>
      </div>

      {/* Edit Inventory Modal */}
      <EditInventoryModal
        visible={isEditModalVisible}
        onCancel={handleCloseEditModal}
        onSuccess={handleEditSuccess}
        eventData={selectedEvent}
      />
    </div>
  );
};

export default InventoryControlPage;